export default "__VITE_ASSET__DRtGi7G3__"